import { Dependencies } from "@planzone/core";
import { HttpClient } from "@planzone/services";
import i18n from "@root/client/translations";

const POLL_INTERVAL_MS = 2000;

function pollJobStatus(jobId: string, token: string): Promise<Blob> {
  return fetch(`/exports/status/${jobId}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((r) => r.json())
    .then(({ status, error }: { status: string; error?: string }) => {
      if (status === "error") {
        return Promise.reject(new Error(error || "Export generation failed"));
      }

      if (status === "done") {
        return fetch(`/exports/download/${jobId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }).then((r) => {
          if (!r.ok) return r.json().then((err) => Promise.reject(err));
          return r.blob();
        });
      }

      return new Promise<Blob>((resolve, reject) =>
        setTimeout(
          () => pollJobStatus(jobId, token).then(resolve).catch(reject),
          POLL_INTERVAL_MS,
        ),
      );
    });
}

function createExportGenerator(
  _httpClient: HttpClient,
  getDateFormat: () => string,
): Dependencies["exportGenerator"] {
  return {
    convert(data, format, author) {
      const token = author.token;

      return fetch("/exports/generate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          data,
          format,
          author,
          language: i18n.language,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          dateFormat: getDateFormat(),
        }),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((err) => Promise.reject(err));
          }
          return response.json();
        })
        .then(({ jobId }: { jobId: string }) => pollJobStatus(jobId, token))
        .then((blob) => URL.createObjectURL(blob));
    },
  };
}

export { createExportGenerator };
